<mat-sidenav-container class="mainWrapper blue_theme  light-theme" autosize autoFocus dir="ltr">
  <!-- <mat-sidenav #leftsidenav [mode]="isOver ? 'over' : 'side'" [opened]="!isOver"
    (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav">
    <app-sidebar></app-sidebar>
  </mat-sidenav> -->
  <mat-sidenav #leftsidenav 
    [mode]="isOver ? 'over' : 'side'" 
    [opened]="!isOver"
    [style.width]="isCollapsed ? '41px !important' : '270px !important'" 
    class="sidebarNav"
    style="overflow: hidden;">
    
    <app-sidebar [isCollapsed]="isCollapsed" (toggleCollapse)="toggleCollapsed()"></app-sidebar>
  </mat-sidenav>

  <!-- <mat-sidenav #leftsidenav [mode]="isOver ? 'over' : 'side'" [opened]="!isOver"
    (openedChange)="onSidenavOpenedChange($event)" (closedStart)="onSidenavClosedStart()" class="sidebarNav sidebarNav-Mobile">
    <app-sidebar></app-sidebar>
  </mat-sidenav> -->

  <mat-sidenav-content class="contentWrapper" [style.margin-left]="isCollapsed ? '41px' : '270px'">
    <app-header [showToggle]="!isOver" (toggleCollapsed)="toggleCollapsed()"
      (toggleMobileNav)="sidenav.toggle()"></app-header>

    <main #scrollContainer class="pageWrapper">
      <router-outlet></router-outlet>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>